import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useSessionStore } from '@/lib/session.js';

export function ProtectedRoute({ children, roles }) {
  const { user, loading, hydrate } = useSessionStore();
  const location = useLocation();

  useEffect(() => {
    if (user === null && loading) hydrate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <div className="p-8 text-center text-sm text-slate-500">Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
